import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UuidService } from './../services/uuid.service';

@Injectable()
export class RegistrationInterceptor implements HttpInterceptor {
  private readonly routes = [
    '/membership/user/email/exists',
    '/membership/user/phonenumber/exists',
    '/membership/user/phonenumber/verification/start',
    '/membership/user/phonenumber/verification/check',
    '/membership/user/password/verify',
    '/membership/user/register',
  ];

  constructor(private uuidService: UuidService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isRegisterRoute(req.urlWithParams)) {
      req = req.clone({
        setHeaders: {
          'x-hohr-register-correlation-id': this.uuidService.getRegisterUuid(),
        },
      });
    }

    return next.handle(req);
  }

  private isRegisterRoute = (routeUrl: string): boolean =>
    !!this.routes.find((route) => routeUrl.includes(route))
}
